import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Login.css'; // Import the CSS file for styling
import loginImage from '../../assets/images/purple-login-floatin-text-bangers.svg'; // Import the SVG
import { useAuth } from '../../context/AuthContext'; // Import useAuth hook

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false); // New state to track success
  const [isLoggingIn, setIsLoggingIn] = useState(false); // New state to track login process
  const navigate = useNavigate();
  const { login } = useAuth(); // Get login function from context

  const API_BASE_URL = process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_PRODUCTION_API_BASE_URL
    : process.env.REACT_APP_API_BASE_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage(''); // Clear any previous messages
    setIsSuccess(false); // Reset success state
    setIsLoggingIn(true); // Set logging in state

    // Basic form validation
    if (!username || !password) {
      setMessage('Please enter both username and password.');
      setIsLoggingIn(false); // Reset logging in state
      return;
    }

    // console.log('Attempting login with:', { username, password });

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: username.toLowerCase(), password }),
      });

      console.log('Response status:', response.status);

      if (response.ok) {
        const data = await response.json();
        // console.log('Login successful:', data); // Commented out to prevent large data dump
        setMessage('Login successful!');
        setIsSuccess(true); // Set success state
        
        // Call context login function instead of directly setting localStorage
        login(username, data.token, data.refreshToken);

        // Delay navigation to allow message display
        setTimeout(() => {
          const redirectUrl = localStorage.getItem('redirectAfterLogin') || '/';
          localStorage.removeItem('redirectAfterLogin');
          // console.log(`Navigating to ${redirectUrl} after login.`); // Add log
          navigate(redirectUrl); 
          // window.location.reload(); // REMOVED: Reload the page to update the header
        }, 1000); // 1-second delay
      } else {
        // --- Improved Error Message Handling ---
        let errorMessage = "Too Many Attempts. Please try again later."; // Default
        try {
          // Try to get the specific message from the backend JSON response
          const errorData = await response.json(); 
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch (jsonError) {
          // If backend didn't send JSON, use the status text (e.g., "Bad Request", "Too Many Requests")
          errorMessage = response.statusText || errorMessage;
        }
        // Prepend status code for clarity
        setMessage(`Error ${response.status}: ${errorMessage}`);
        // -------------------------------------
        setIsLoggingIn(false); // Reset logging in state
      }
    } catch (error) {
      // Network errors or other issues with the fetch call itself
      console.error('Network or other error during login:', error);
      setMessage('An error occurred during login. Please check your connection.');
      setIsLoggingIn(false); // Reset logging in state
    }
  };

  return (
    <div className="login-page">
      <h1 className="login-title">
        <img src={loginImage} alt="Login" />
      </h1>
      <div className="login-form-container">
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button" disabled={isLoggingIn || isSuccess}>
            Login
          </button>
        </form>
        {message && (
          <div className={`message ${isSuccess ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
        <div className="signup-prompt">
          Don't have an account? <Link to="/signup">Sign Up</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
